export const REPORTS_HANDLE_MODAL_EXTRA_TIME = "REPORTS_HANDLE_MODAL_EXTRA_TIME";

